export default __webpack_public_path__ + "static/family-20e1cc4e9421744509f4f927ecec7e5f.png";